import React, { useState, useEffect } from 'react';
import { View, Text, Image } from 'react-native';
import { Checkbox } from 'react-native-paper';

import HeaderDefault from '../../components/HeaderDefault';
import Button from '../../components/Button';

import AsyncStorage from '@react-native-async-storage/async-storage';

import api from '../../services/api';

import styles from './styles';
import balanceService from '../../services/balanceService';
import { TouchableOpacity } from 'react-native-gesture-handler';
import { LinearGradient } from 'expo-linear-gradient';
import clientService from '../../services/clientService';
import { useNavigation } from '@react-navigation/core';
import toast from '../../utils/toast';
import feeService from '../../services/feeService';
import { formatCoin, formatGPXBalance } from '../../utils/formatNumber'
/*
 * ROUTE PARAMS -> qtd (float), token (actives.activeId), viewType(buy|sell), market (optional:true|false,default:false)
 */

const ConfirmPaperWallet = (props) => {

    const [uri, setUri] = useState('');
    const [nameToken, setNameToken] = useState('GPX');
    const [valueToken, setValueToken] = useState(1);

    const [qtd, setQtd] = useState(1);

    const [activeIdTokenId, setActiveIdTokenId] = useState();
    const [activeIdTokenObj, setActiveIdTokenObj] = useState();
    const [balance, setBalance] = useState(0); // Active/Token Balance
    const [balanceGPX, setBalanceGPX] = useState(0); // GPX Balance
    const [authToken, setAuthToken] = useState();
    const [taxes, setTaxes] = useState(0.1);
    const [fee, setFee] = useState({
        fee: 0.1,
        type: 'fixed'
    });

    const [findUserBy, setFindUserBy] = useState('');
    const [userKey, setUserKey] = useState('');
    const [toUser, setToUser] = useState();

    //TODO: Carregar taxas.

    const navigation = useNavigation();

    useEffect(() => {
        loadTokenAndRequest();
    }, []);

    useEffect(() => {
        if (props.route.params.qtd) // amount to paperwallet
            setQtd(props.route.params.qtd);
        else
            setQtd(1);
        if (props.route.params.token) // token/active to paperwallet
            setActiveIdTokenId(props.route.params.token);
    }, []);

    useEffect(() => {
        getDataCoin();
        loadBalance();
    }, [activeIdTokenId]);

    useEffect(() => {
        if (authToken) {
            loadBalance();
            loadFees();
        }
    }, [authToken]);

    const loadTokenAndRequest = async () => {
        const authTokenStorage = await AsyncStorage.getItem('JWT_TOKEN');
        setAuthToken(authTokenStorage);
    }

    const loadBalance = () => {
        if (authToken) {
            if (activeIdTokenId !== -1) {
                balanceService.getBalanceOfToken(authToken, activeIdTokenId).then((response) => {
                    setBalance(response?.data?.saldo + '');
                }).catch((error) => {
                });
            }
            balanceService.getBalanceOfGpx(authToken).then((res) => {
                if (res?.data?.balance?.length > 0) {
                    let balanceReturn = 0;
                    if (res.data.balance[0]?.available_balance) {
                        balanceReturn = res.data.balance[0].available_balance;
                    } else {
                        balanceReturn = res.data.balance[0].saldo;
                    }
                    setBalanceGPX(balanceReturn);
                    if (activeIdTokenId === -1) {
                        setBalance(balanceReturn);
                    }
                }
            }).catch((error) => {
            });
        }
    }

    const getDataCoin = async () => {
        const token = await AsyncStorage.getItem('JWT_TOKEN');
        if (activeIdTokenId && activeIdTokenId !== -1) {
            api.get(`/actives/${activeIdTokenId}`, { headers: { 'Authorization': `Basic ${token}` } })
                .then((res) => {
                    if (res.data.actives.length > 0) {
                        //    console.log(res.data.actives);
                        setActiveIdTokenObj(res.data.actives[0]);
                        setNameToken(res.data.actives[0].name_token)
                        setUri(`https://filesgpx.s3.us-east-2.amazonaws.com/${res.data.actives[0].path}`)
                        setValueToken(res.data.actives[0].single_value); //TODO: Implementar valores fixos e flutuantes -> BUG
                        // res.data.actives[0].type_value == "Valor Fixo" ?
                        //     setValueToken(res.data.actives[0].single_value)
                        // :   setValueToken(res.data.actives[0].total_value_token)
                    }
                })
                .catch((error) => {
                    //console.log(error);
                });
        } else {
            setActiveIdTokenObj({
                id: -1,
                name_token: 'GPX/BRL',
                single_value: 1,
                amount_token: '=',
                cryptoactive: false
            });
            setNameToken('GPX/BRL');
            setUri('');
            setValueToken(1);
        }
    }

    const loadFees = () => {
        if (authToken) {
            if (activeIdTokenId !== -1) {

                feeService.getTransferOutFeeByActiveId(authToken, activeIdTokenId).then((response) => {
                    if (response.status === 200) {
                        setFee(response.data);
                    } else {
                        console.log('unable to load fee')
                    }
                }).catch((error) => { console.log('unable to load fee') });
            } else {
                setFee({ fee: 0.0099, type: 'factor' });
            }
        }
    }

    const getCurrentFee = () => {
        if (activeIdTokenObj?.cryptoactive && fee.type) {
            return (fee.type === 'fixed' ? (parseFloat(fee.fee)) : (parseFloat(fee.fee) * parseFloat(qtd)));
        } else if (fee.type) {
            return (fee.type === 'fixed' ? fee.fee : (parseFloat(fee.fee) * parseFloat(qtd) * parseFloat(valueToken))); // descontado no recebimento
        }
    }

    const getTotalReceive = () => {
        let currentFee = getCurrentFee();
        if (activeIdTokenObj?.cryptoactive && fee.type) {
            return qtd - currentFee;
        } else if (fee.type) {
            return qtd;
        }
    }

    const getBalanceToken = () => {
        return balance - qtd;
    }

    const getBalanceGPX = () => {
        let currentFee = getCurrentFee();
        if (activeIdTokenObj?.cryptoactive && fee.type) {
            return balanceGPX;
        } else if (fee.type) {
            return balanceGPX - currentFee;
        }
    }

    return (
        <>
            <HeaderDefault title={'Confirmar Saque Paper Wallet'} />

            <View style={styles.container}>
                <Text style={styles.title}>Você confirma o saque abaixo?</Text>

                <View style={styles.contentImgsCoins}>
                    {uri === '' ?
                        <Image source={require('../../../assets/imgs/gpx.png')} style={styles.imgCoins} />
                        :
                        <Image source={{ uri: uri }} style={styles.imgCoins} />
                    }
                </View>

                <View style={styles.contentPrice}>
                    <Text style={{ textAlign: 'center' }}>Saque para Paper Wallet</Text>
                    <Text style={styles.price}>{qtd} {nameToken}</Text>
                </View>

                <View style={styles.hr} />

                {
                    (activeIdTokenObj?.cryptoactive) &&
                    <View style={styles.confirmDataRow}>
                        <Text style={styles.confirmDataRowColTitle}>Taxa</Text>
                        <Text style={styles.confirmDataRowColText}>{getCurrentFee()} {activeIdTokenObj?.name_token}</Text>
                    </View>
                }
                <View style={styles.confirmDataRow}>
                    <Text style={styles.confirmDataRowColTitle}>Total a sacar</Text>
                    <Text style={styles.confirmDataRowColText}>{getTotalReceive()} {activeIdTokenObj?.name_token}</Text>
                </View>

                {
                    activeIdTokenId === -1 ?
                        <>
                            <View style={{ ...styles.confirmDataRow, marginTop: 15 }}>
                                <Text style={styles.confirmDataRowColTitle}>Saldo GPX/BRL</Text>
                                <Text style={styles.confirmDataRowColText}>{formatGPXBalance(balanceGPX)} GPX/BRL</Text>
                            </View>
                            <View style={styles.confirmDataRow}>
                                <Text style={styles.confirmDataRowColTitle}>Taxa</Text>
                                <Text style={styles.confirmDataRowColText}>{formatGPXBalance(getCurrentFee())} GPX/BRL</Text>
                            </View>
                            <View style={styles.confirmDataRow}>
                                <Text style={styles.confirmDataRowColTitle}>Saldo GPX/BRL após saque.</Text>
                                <Text style={styles.confirmDataRowColText}>{formatGPXBalance(getBalanceToken() - getCurrentFee())} GPX/BRL</Text>
                            </View>
                        </>
                        :
                        <>
                            <View style={{ ...styles.confirmDataRow, marginTop: 15 }}>
                                <Text style={styles.confirmDataRowColTitle}>Saldo</Text>
                                <Text style={styles.confirmDataRowColText}>{balance} {activeIdTokenObj?.name_token}</Text>
                            </View>
                            <View style={styles.confirmDataRow}>
                                <Text style={styles.confirmDataRowColTitle}>Saldo após saque.</Text>
                                <Text style={styles.confirmDataRowColText}>{getBalanceToken()} {activeIdTokenObj?.name_token}</Text>
                            </View>

                            <View style={{ ...styles.confirmDataRow, marginTop: 15 }}>
                                <Text style={styles.confirmDataRowColTitle}>Saldo GPX/BRL</Text>
                                <Text style={styles.confirmDataRowColText}>{formatGPXBalance(balanceGPX)} GPX/BRL</Text>
                            </View>
                            {
                                !(activeIdTokenObj?.cryptoactive) &&
                                <View style={styles.confirmDataRow}>
                                    <Text style={styles.confirmDataRowColTitle}>Taxa</Text>
                                    <Text style={styles.confirmDataRowColText}>{formatCoin(getCurrentFee(), (activeIdTokenObj?.feezeroMk ? activeIdTokenObj?.feezeroMk : 2))} {activeIdTokenObj?.name_token}</Text>
                                </View>
                            }
                            <View style={styles.confirmDataRow}>
                                <Text style={styles.confirmDataRowColTitle}>Saldo GPX/BRL após saque.</Text>
                                <Text style={styles.confirmDataRowColText}>{formatGPXBalance(getBalanceGPX())} GPX/BRL</Text>
                            </View>
                        </>
                }


            </View>
            {
                parseFloat(balance) < qtd ?
                    <Button route={"DepositMethod"} text={"SALDO INSUFICIENTE"} props={{}} />
                    :
                    <View style={styles.contentBtn}>
                        <TouchableOpacity onPress={() => props.navigation.navigate({
                            name: 'ConfirmPasswordPaperWallet', params: {
                                qtd: qtd,
                                token: activeIdTokenId
                            }
                        })}>
                            <LinearGradient
                                start={{ x: -1, y: 0 }}
                                end={{ x: 1, y: 0 }}
                                colors={["#16195B", "#1FBFB5"]}
                                style={styles.btn}
                            >
                                <Text style={styles.textBtn}>CONFIRMAR</Text>
                            </LinearGradient>
                        </TouchableOpacity>
                    </View>
            }

        </>
    );
}

export default ConfirmPaperWallet;